import React, { useEffect, useRef } from "react"
import { Grid } from "@mui/material"
import ReportExtraFormDrawer from "Pages/ReportsAlerts/Reports/Extra/Page/Drawer"
import ReportCrudTable from "Pages/ReportsAlerts/Reports/@components/CrudTable"
import ReportInfoModal from "Pages/ReportsAlerts/Reports/@components/InfoModal"
import ReportListSearchSummaryModal from "Pages/ReportsAlerts/Reports/@components/SearchesDrawer"
import ReportListMultipleModal from "Pages/ReportsAlerts/Reports/@components/MultipleModal"
import { resetSignals, selectedReportTypeTab } from "Pages/ReportsAlerts/Reports/@signals"
import { REPORT_TYPE_TABS } from "Pages/ReportsAlerts/Reports/@constants"


export default function ReportsExtraPageContent({ hideCrudTable = false }) {

	const initialized = useRef(false)
	if (!initialized.current) {
		initialized.current = true
		selectedReportTypeTab.value = REPORT_TYPE_TABS.REPORTS
	}

	useEffect(() => {
		return () => {
			resetSignals()
		}
	}, [])

	return <Grid container spacing={2}>
		<Grid item xs={12}>
			<ReportExtraFormDrawer/>
		</Grid>
		{!hideCrudTable && <Grid item xs={12}>
			<ReportCrudTable/>
		</Grid>}
		<Grid item xs={12}>
			<ReportInfoModal/>
		</Grid>
		<Grid item xs={12}>
			<ReportListSearchSummaryModal/>
		</Grid>
		<Grid item xs={12}>
			<ReportListMultipleModal/>
		</Grid>
	</Grid>
}